import React from 'react';
import { ArrowRight, Calendar } from 'lucide-react';

const CTA = () => {
  return (
    <section className="relative py-20 lg:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-slate-950 px-8 lg:px-14 py-14 lg:py-16">
          {/* Ambient */}
          <div
            aria-hidden
            className="absolute inset-0 opacity-40"
          >
            <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-indigo-600 blur-[120px] opacity-40" />
            <div className="absolute -bottom-24 -right-24 w-96 h-96 rounded-full bg-fuchsia-500 blur-[120px] opacity-30" />
          </div>
          <div
            aria-hidden
            className="absolute inset-0 opacity-[0.08] [background-image:linear-gradient(to_right,#fff_1px,transparent_1px),linear-gradient(to_bottom,#fff_1px,transparent_1px)] [background-size:40px_40px] [mask-image:radial-gradient(ellipse_at_center,black_40%,transparent_75%)]"
          />

          <div className="relative flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
            <div className="max-w-2xl">
              <h2 className="font-display text-[32px] md:text-[44px] leading-[1.05] font-semibold tracking-tight text-white">
                Let’s ship something that{' '}
                <span className="bg-gradient-to-r from-cyan-300 via-indigo-300 to-violet-300 bg-clip-text text-transparent">
                  won’t page you at 3am.
                </span>
              </h2>
              <p className="mt-4 text-[15.5px] leading-relaxed text-slate-300 max-w-xl">
                Book a 30-minute discovery call. We’ll listen, ask sharp questions, and share whether we’re the right fit - in plain English.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#contact"
                className="group inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-white text-slate-900 font-medium hover:bg-slate-100 transition-colors"
              >
                <Calendar size={16} />
                Book a call
                <ArrowRight size={16} className="transition-transform group-hover:translate-x-0.5" />
              </a>
              <a
                href="#services"
                className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl border border-white/20 bg-white/5 text-white font-medium hover:bg-white/10 transition-colors"
              >
                Explore services
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
